import React, { useState, useContext } from "react";
import styles from "../../styles/components/UI/InputPasswordSelector.module.css";
import { ErrorPopup } from "../error/ErrorPopup";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ThemeContext } from "../../context/ThemeContext";

export const InputPasswordSelector = ({
  filterName,
  selectedValue,
  handleFilterChange,
  hasError,
  errorMessage,
  isFocused,
  onFocus,
  onBlur,
  disabled,
}) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';
  const [isMouseEnter, setIsMouseEnter] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleMouseEnter = () => {
    setIsMouseEnter(true);
  };

  const handleMouseLeave = () => {
    setIsMouseEnter(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  return (
    <div className={styles.inputContainer}>
      <div className={`${styles.inputWrapper} ${hasError ? styles.errorBorder : ''} ${isFocused ? styles.focused : ''} ${isDark ? styles.darkInputWrapper : ''}`}>
        <input
          type={showPassword ? "text" : "password"}
          name={filterName}
          value={selectedValue ?? ''}
          onChange={(e) => handleFilterChange(filterName, e.target.value)}

          onFocus={() => onFocus && onFocus(filterName)}
          onBlur={() => onBlur && onBlur(filterName)}

          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}

          disabled={disabled}

          className={`${styles.input} ${hasError ? styles.error : ""} ${isDark ? styles.darkInput : ''}`}
        />

        <div
          className={`${styles.visibilityToggle} ${isDark ? styles.darkVisibilityToggle : ''}`}
          onClick={togglePasswordVisibility}
        >
          {showPassword ? (
            <VisibilityOffIcon fontSize="small" />
          ) : (
            <VisibilityIcon fontSize="small" />
          )}
        </div>
      </div>

      {hasError && isMouseEnter && errorMessage && <ErrorPopup message={errorMessage} theme={theme} />}
    </div>
  );
};
